import { Tooltip } from '@mantine/core'
import { format, formatDistance } from 'date-fns'
import type { ReactNode } from 'react'

export function RelativeDateTimeDisplay(props: {
  value: string | Date | null | undefined
  toDate?: string | Date | null | undefined
  // must be an HTML element or React component
  element?: string | React.ComponentType<any>
  className?: string
}): ReactNode {
  const { value, className } = props
  if (!value) {
    return null
  }
  const date = typeof value === 'string' ? new Date(value) : value
  const toDate = props.toDate ?? new Date()
  const formattedDate = formatDistance(date, toDate)
  const Element = props.element ?? 'div'
  return (
    <Tooltip label={format(date, 'PPpp')} position="top-start">
      <Element className={className}>{formattedDate} ago</Element>
    </Tooltip>
  )
}
